<template>
  <div class="article_con">
    <div class="article_bg">
      <!-- <div class="article_con_title">{{item[this.$route.params.id].title}}</div> -->
      <div class="article_con_title">{{article.title}}</div>
      <br>
      <!-- <p v-html="item[this.$route.params.id].con"></p> -->
      <p v-html="article.text"></p>

      <br>
    </div>
  </div>
</template>



<style>
.article_con {
  padding: 20px 250px;
}
.article_con_title {
  font-size: 20px;
  border-bottom: 1px dotted #cccccc;
  color: #00ad74;
  line-height: 40px;
}
/* .article_con p {
  font-size: 14px;
  font-weight: lighter;
  text-indent: 2em;
  line-height: 28px;
}

.article_con h1 {
  padding-bottom: 0.4rem;
  font-size: 2.2rem;
  line-height: 1.3;
}

.article_con h2 {
  font-size: 1.75rem;
  line-height: 1.225;
  margin: 35px 0 15px;
  padding-bottom: 0.5em;
  border-bottom: 1px solid #ddd;
}

.article_con h3 {
  font-size: 1.4rem;
  line-height: 1.43;
  margin: 20px 0 7px;
}

.article_con h4 {
  font-size: 1.2rem;
}

.article_con.article_con h5 {
  font-size: 1rem;
}

.article_con h6 {
  font-size: 1rem;
  color: #777;
}
.article_con blockquote {
  border-left: 4px solid #42b983;
  padding: 10px 15px;
  color: #777;
  background-color: rgba(66, 185, 131, 0.1);
}
.article_con a {
  color: #42b983;
  font-weight: 600;
  padding: 0 2px;
  text-decoration: none;
}
table {
  border-collapse: collapse;
}
table,
td,
th {
  border: 1px solid black;
} */
</style>
<script>
import axios from 'axios'
export default {
  created () {
    this.getMessage()
  },
 methods: {
    getMessage () {
      const path = 'https://admin.dongqunjiaoyu.com/api/posts/';
      var article_path = path + this.$route.params.id;
      axios.get(article_path)
        .then((res) => {
          this.article = res.data;
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error);
        })
    }
  },



  data() {
    return {
      article:null,
    };
  },

};
</script>
